const initState = {url:'https://plato.monmouth.edu/~s1317086'}
//const initState = {url:'http://localhost:82'}
export default function Backurl(urlState=initState,action){
	return urlState
}
